import React from 'react'

export default function ServiceUnavailableError() {
  return (
    <div className="ob-error">
      <h1 className="zb-heading2">The Service is currently unavailable</h1>
      <div className="zb-card">
        <div className="zb-card-body">
          The Access Store is temporarily unavailable. We are working on fixing
          the issue as quickly as possible and appreciate your patience during
          this time. We apologise for the inconvenience. Please close this page
          and try again later.
        </div>
      </div>
    </div>
  )
}
